import { Card, CardHeader, Pagination } from "@mui/material";
import UsersApi from "Classes/API/UsersApi";
import SearchFeedbackStatistics from "Classes/Models/Requests/Administration/Statistics/SearchFeedbackStatistics";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Loader from "layouts/loader/loader";
import { useEffect, useState, useMemo, memo } from "react";
import DateTimePicker from "react-datetime-picker/dist/DateTimePicker";
import { useNavigate } from "react-router-dom";
import ChartComponent from "./ChartComponent";
import CycleChart from "./CycleChart";
import { useContext } from "react";
import { LanguageContext } from "App";
import MDButton from "components/MDButton";
const MemoizedChartComponent = memo(ChartComponent);
const MemoizedCycleChart = memo(CycleChart);

const StarRating = memo(({ rating }) => {
  const stars = Array.from({ length: 5 }, (_, index) => (
    <span key={index} style={{ color: index < rating ? "gold" : "gray" }}>
      &#9733;
    </span>
  ));
  return <div>{stars}</div>;
});
const FeedbackStatistics = () => {
  const navigate = useNavigate();

  const GetOptions = (session) => {
    navigate("/AccountingSessions/Details", {
      state: {
        SearchSession: session,
      },
    });
  };

  const [PaginationPages, setPaginationPages] = useState(0);
  const [Page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const initialToDate = new Date();
  initialToDate.setMonth(initialToDate.getMonth() - 1);
  const { translations } = useContext(LanguageContext);
  const [ToDate, setToDate] = useState(null); // One month ago
  const [FromDate, setFromDate] = useState(null); // Today's date
  const [session, setSession] = useState(new Object()); // Today's date
  const [feedbackData, setFeedbackData] = useState([]);
  const [sessionsParentAndChilds, setSessionsParentAndChilds] = useState([]);
  const [extraData, setExtraData] = useState([]);
  const [shouldUpdateChart, setShouldUpdateChart] = useState(true);
  useEffect(() => {
    // Fetch initial data
    onSubmit();
    getSessionsParentAndChilds();
  }, []);

  useEffect(async () => {
    await onSubmit();
  }, [Page]);

  const dynamicChartData = useMemo(
    () => ({
      labels: ["zero", "one", "two", "three", "four", "five"],
      datasets: [
        {
          label: "Ratings",
          data: [
            extraData.numberOfRatingsForZero,
            extraData.numberOfRatingsForOne,
            extraData.numberOfRatingsForTwo,
            extraData.numberOfRatingsForThree,
            extraData.numberOfRatingsForFour,
            extraData.numberOfRatingsForFive,
          ],
          backgroundColor: [
            "rgba(255, 99, 132, 0.5)",
            "rgba(54, 162, 235, 0.5)",
            "rgba(255, 206, 86, 0.5)",
            "rgba(75, 192, 192, 0.5)",
            "rgba(153, 102, 255, 0.5)",
            "rgba(255, 159, 64, 0.5)",
          ],
          borderColor: [
            "rgba(255, 99, 132, 1)",
            "rgba(54, 162, 235, 1)",
            "rgba(255, 206, 86, 1)",
            "rgba(75, 192, 192, 1)",
            "rgba(153, 102, 255, 1)",
            "rgba(255, 159, 64, 1)",
          ],
          borderWidth: 1,
        },
      ],
    }),
    [extraData]
  );

  const StarRating = ({ rating }) => {
    const stars = Array.from({ length: 5 }, (_, index) => (
      <span key={index} style={{ color: index < rating ? "gold" : "gray" }}>
        &#9733;
      </span>
    ));

    return <div>{stars}</div>;
  };

  const onSubmit = (event) => {
    setLoading(true);
    if (event) {
      event.preventDefault();
    }

    let SearchFeedback = new SearchFeedbackStatistics();
    SearchFeedback.FromDate = FromDate;
    SearchFeedback.ToDate = ToDate;
    SearchFeedback.Session = sessionsParentAndChilds?.find((x) => x.id == session);
    SearchFeedback.pagingParams.pageNumber = Page;
    SearchFeedback.pagingParams.pageSize = 10;
    console.log("SearchFeedback: ", SearchFeedback);

    UsersApi.SearchFeedbackStatistics(SearchFeedback).then((result) => {
      if (result.status == "Success") {
        console.log("result: ", result);
        setFeedbackData(result.data.list);
        setExtraData(result.extraData);
        setPaginationPages(result.data.totalPages);
      }
      setLoading(false);
    });
  };

  const getSessionsParentAndChilds = () => {
    UsersApi.getSessionsParentAndChilds().then((result) => {
      setSessionsParentAndChilds(result.data);
    });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {loading && <Loader />}
      {!loading && (
        <div>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <Card sx={{ padding: "1em", margin: "1em 0 0 0" }}>
                  <MDBox
                    pt={2}
                    px={2}
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <MDTypography variant="h6" fontWeight="medium">
                      {translations.StasticsFeedbackFilterby}
                    </MDTypography>
                    <div>
                      <MDButton
                        type="button"
                        sx={{
                          backgroundColor: "#3560AD",
                          "&:hover": { backgroundColor: "#4682B4" },
                        }}
                        color="text"
                        onClick={() => onSubmit()}
                      >
                        {translations.StasticsFeedbackSearch}
                      </MDButton>
                    </div>
                  </MDBox>

                  <MDBox mb={3} sx={{ display: "flex", justifyContent: "space-around" }}>
                    <div className="container-fluid">
                      <div className="row">
                        <div className="col-md-4">
                          <MDTypography mr={2} variant="button" fontWeight="regular" color="text">
                            {translations.StasticsFeedbackFromDate}:
                          </MDTypography>
                          <DateTimePicker onChange={(e) => setFromDate(e)} value={FromDate} />
                        </div>
                        <div className="col-md-4">
                          <MDTypography mr={2} variant="button" fontWeight="regular" color="text">
                            {translations.StasticsFeedbackToDate}:
                          </MDTypography>
                          <DateTimePicker onChange={(e) => setToDate(e)} value={ToDate} />
                        </div>
                        <div className="col-md-4">
                          {/* <MDTypography mr={2} variant="button" fontWeight="regular" color="text">
                            {translations.StasticsFeedbackSelectSession}:
                          </MDTypography>
                          <br></br>
                          <select onChange={(e) => setSession(e.target.value)}>
                            <option value="">{translations.StasticsFeedbackSelectSession}</option>
                            {sessionsParentAndChilds.map((session) => (
                              <option key={session.id} value={session.id}>
                                {session.name}
                              </option>
                            ))}
                          </select> */}
                        </div>
                      </div>
                    </div>
                  </MDBox>
                </Card>
              </div>
            </div>
          </div>

          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6">
                <Card sx={{ padding: "1em", margin: "1em 0 0 0", backgroundColor: "#ff6384" }}>
                  <CardHeader title={translations.StasticsFeedbackRatingsAverage} />
                  <MDBox mb={3} sx={{ display: "flex", justifyContent: "space-around" }}>
                    {Number(extraData.averageRating).toFixed(2)}
                  </MDBox>
                </Card>
              </div>
              <div className="col-md-6">
                <Card sx={{ padding: "1em", margin: "1em 0 0 0", backgroundColor: "#ffce56" }}>
                  <CardHeader title={translations.StasticsFeedbackFeedbackCount} />
                  <MDBox mb={3} sx={{ display: "flex", justifyContent: "space-around" }}>
                    {extraData.numberOfRatings}
                  </MDBox>
                </Card>
              </div>
              {/* <div className="col-md-4">
                <Card sx={{ padding: "1em", margin: "1em 0 0 0", backgroundColor: "#36a2eb" }}>
                  <CardHeader title={translations.StasticsFeedbackTotalSessionsTypes} />
                  <MDBox mb={3} sx={{ display: "flex", justifyContent: "space-around" }}>
                    {extraData.totalSessionsTypes}
                  </MDBox>
                </Card>
              </div> */}
            </div>
          </div>

          <div className="container-fluid" style={{ display: "flex", flexDirection: "column" }}>
            <div className="row" style={{ display: "flex", flex: 1 }}>
              <div className="col-md-4" style={{ display: "flex", flexDirection: "column" }}>
                <Card sx={{ padding: "1em", margin: "1em 0 0 0", flex: 1 }}>
                  <CardHeader title={translations.StasticsFeedbackSessionstypes} />
                  <MDBox mb={3} sx={{ display: "flex", justifyContent: "space-around" }}>
                    {extraData?.daysDistnicts && (
                      <MemoizedCycleChart data={extraData.daysDistnicts} />
                    )}
                  </MDBox>
                </Card>
              </div>
              <div className="col-md-8" style={{ display: "flex", flexDirection: "column" }}>
                <Card sx={{ padding: "1em", margin: "1em 0 0 0", flex: 1 }}>
                  <CardHeader title={translations.StasticsFeedbackRatingschart} />
                  <MDBox mb={3}>
                    <MemoizedChartComponent chartData={dynamicChartData} />
                  </MDBox>
                </Card>
              </div>
            </div>
          </div>

          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <Card className="mt-5">
                  <MDBox
                    mx={4}
                    mt={-3}
                    py={3}
                    px={2}
                    sx={{ backgroundColor: "#3560AD" }}
                    variant="gradient"
                    borderRadius="lg"
                    coloredShadow="info"
                  >
                    <div className="text-center">
                      <MDTypography variant="h6" color="white">
                        {translations.StasticsFeedbackFeedbackStatisticTable}
                      </MDTypography>
                    </div>
                  </MDBox>
                  <MDBox p={3}>
                    <table
                      className="table bordered"
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        marginTop: "20px",
                        fontSize: "14px",
                      }}
                    >
                      <thead>
                        <tr style={{ borderBottom: "1px solid #ddd" }}>
                          <th>#</th>
                          <th>{translations.StasticsFeedbackRate}</th>
                          <th>{translations.StasticsFeedbackDescription}</th>
                          <th>{translations.StasticsFeedbackPatientName}</th>
                          <th>{translations.StasticsFeedbackdoctorName}</th>
                          {/* <th>{translations.StasticsFeedbackSessionName}</th> */}
                          <th>{translations.StasticsFeedbackTimeStamp}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {feedbackData.map((feedback, index) => (
                          <tr key={feedback.id} style={{ borderBottom: "1px solid #ddd" }}>
                            <td>{feedback.id}</td>
                            <td>
                              <StarRating rating={feedback.rate} />
                            </td>
                            <td style={{ wordBreak: "break-word" }}>{feedback.description}</td>
                            <td>
                              {feedback.accountingSession?.patientName == null
                                ? feedback.patientName
                                : ""}
                            </td>
                            <td>
                              {feedback.accountingSession?.doctorName == null
                                ? feedback.doctorName
                                : ""}
                            </td>
                            {/* <td>
                              <a
                                style={{ cursor: "pointer", color: "blue" }}
                                onClick={() => GetOptions(feedback.accountingSession)}
                              >
                                {feedback.accountingSession?.sessionName}
                              </a>
                            </td> */}
                            <td>{new Date(feedback.timeStamp).toLocaleString()}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </MDBox>

                  <div className="text-right mx-3 my-4">
                    <Pagination
                      count={PaginationPages}
                      color="primary"
                      onChange={(e, number) => setPage(number)}
                      className="float-right"
                    />
                  </div>
                </Card>
              </div>
            </div>
          </div>
        </div>
      )}
    </DashboardLayout>
  );
};

export default FeedbackStatistics;
